var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14.6,
    viewBox: "0 0 19 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39007 11.7879C10.4568 11.7879 11.4997 11.4716 12.3867 10.879C13.2737 10.2863 13.965 9.444 14.3733 8.45846C14.7816 7.47291 14.8885 6.38843 14.6805 5.34213C14.4725 4.29584 13.9589 3.33472 13.2046 2.58031C12.4504 1.8259 11.4894 1.31207 10.4432 1.1038C9.39692 0.89553 8.31241 1.00217 7.32677 1.41023C6.34113 1.81829 5.49861 2.50945 4.90576 3.39632C4.31291 4.28318 3.99635 5.32593 3.99609 6.3927C3.99593 7.10115 4.13532 7.8027 4.40632 8.45727C4.67732 9.11185 5.07461 9.70663 5.5755 10.2076C6.07639 10.7087 6.67108 11.1061 7.32559 11.3772C7.9801 11.6484 8.68161 11.7879 9.39007 11.7879Z",
    stroke: "#FF5E4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.8634C1 19.4101 1.57731 18.0163 2.60494 16.9887C3.63256 15.9611 5.02631 15.3838 6.47959 15.3838H12.3017C13.7549 15.3838 15.1487 15.9611 16.1763 16.9887C17.2039 18.0163 17.7812 19.4101 17.7812 20.8634C17.7799 21.9522 17.3465 22.996 16.5762 23.7656C15.8059 24.5352 14.7617 24.9676 13.6728 24.968H5.11097C4.02168 24.9683 2.97681 24.5362 2.20596 23.7665C1.43511 22.9969 1.00135 21.9527 1 20.8634Z",
    stroke: "#FF5E4F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.f908b94f03c66e78ae053b345775f069.svg";
export { ForwardRef as ReactComponent };